import * as $ from 'jquery';

export function initPhoneClickLogging() {
  $(function () {
    $('.phone-click-log').on('click', function (event) {
      const phone = $(this).data('original').trim();
      const campId = $("input[name='camp_id']").val();
      const sourceUrl = window.location.href;

      const csrfToken = $('meta[name="csrf-token"]').attr('content');
      $.ajax({
        url: '/phone_logs',
        type: 'POST',
        data: {
          phone: phone,
          camp_id: campId,
          source_text: 'Сайт ОР',
          source_url: sourceUrl,
          authenticity_token: csrfToken,
        },
      });
    });
  });
}
